var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 10.1875V5C24.25 4.44772 23.8023 4 23.25 4H19.25M24.25 10.1875H1.75M24.25 10.1875V24.25C24.25 24.8023 23.8023 25.25 23.25 25.25H2.75C2.19772 25.25 1.75 24.8023 1.75 24.25V10.1875M1.75 10.1875V5C1.75 4.44772 2.19772 4 2.75 4H6.75M6.75 4V0.25M6.75 4H19.25M19.25 4V0.25M15.5 18.375V16.5H19.25V18.375M15.5 18.375V20.25H19.25V18.375M15.5 18.375H19.25",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEvent);
export default __webpack_public_path__ + "static/media/calendar-event.32c54180240fec203cffb7a51e0e56e8.svg";
export { ForwardRef as ReactComponent };